import React from "react";
import Cleave from 'cleave.js/react';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function FormularioDevolucionModal({
    show,
    onClose,
    montoDevolver,
    titularCompra,
    banco,
    cuil,
    numCuenta,
    cbu,
    alias,
    dni,
    numeroComprobante,
    onChange,
    cupon,
    autorizacion,
    onSubmit
}) {
    return (
        <Modal show={show} onHide={onClose} size="lg" backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Datos para devolución</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form-horizontal form-material">

                    <h6 className="mt-3">Datos del titular</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="montoDevolver">Monto a devolver</label>
                                <input
                                    id="montoDevolver"
                                    type="text"
                                    className="form-control"
                                    name="montoDevolver"
                                    value={montoDevolver}
                                    onChange={onChange}
                                    placeholder="Ej: 3500.00"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="titularCompra">Titular de la cuenta</label>
                                <input
                                    id="titularCompra"
                                    className="form-control"
                                    name="titularCompra"
                                    value={titularCompra}
                                    onChange={onChange}
                                    placeholder="Nombre completo"
                                    autoComplete="name"
                                />
                            </div>
                        </div>
                    </div>

                    <h6 className="mt-4">Datos bancarios</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="cuil">CUIL</label>
                                <Cleave
                                    id="cuil"
                                    className="form-control"
                                    name="cuil"
                                    options={{ blocks: [2, 8, 1], delimiter: '-', numericOnly: true }}
                                    value={cuil}
                                    onChange={onChange}
                                    placeholder="Ej: 20-12345678-9"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="banco">Banco</label>
                                <input
                                    id="banco"
                                    type="text"
                                    className="form-control"
                                    name="banco"
                                    value={banco}
                                    onChange={onChange}
                                    placeholder="Nombre del banco"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="numCuenta">Número de cuenta</label>
                                <input
                                    id="numCuenta"
                                    type="text"
                                    className="form-control"
                                    name="numCuenta"
                                    value={numCuenta}
                                    onChange={onChange}
                                    placeholder="Ej: 123456789"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="cbu">CBU</label>
                                <input
                                    id="cbu"
                                    type="text"
                                    className="form-control"
                                    name="cbu"
                                    value={cbu}
                                    onChange={onChange}
                                    placeholder="Ej: 0123456789012345678901"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="alias">Alias</label>
                                <input
                                    id="alias"
                                    type="text"
                                    className="form-control"
                                    name="alias"
                                    value={alias}
                                    onChange={onChange}
                                    placeholder="Ej: miprimer.cbu.alias"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="dni">DNI</label>
                                <input
                                    id="dni"
                                    type="text"
                                    className="form-control"
                                    name="dni"
                                    value={dni}
                                    onChange={onChange}
                                    placeholder="Ej: 12345678"
                                    maxLength={8}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>
                      <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="cupon">Cupón</label>
                                <input
                                    id="cupon"
                                    type="text"
                                    className="form-control"
                                    name="cupon"
                                    value={cupon}
                                    onChange={onChange}
                                    placeholder="Ej:cupon"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="autorizacion">Autorizacíon</label>
                                <input
                                    id="autorizacion"
                                    type="text"
                                    className="form-control"
                                    name="autorizacion"
                                    value={autorizacion}
                                    onChange={onChange}
                                    placeholder="Ej: 1"
                                    maxLength={8}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>


                    <h6 className="mt-4">Otros datos</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="numeroComprobante">N° de comprobante</label>
                                <input
                                    id="numeroComprobante"
                                    type="text"
                                    className="form-control"
                                    name="numeroComprobante"
                                    value={numeroComprobante}
                                    onChange={onChange}
                                    placeholder="Ej: 0001-12345678"
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <button className="btn m-r-10 btn-sm btn-grey mb-md-2" onClick={onClose}>
                    Cancelar
                </button>
                <button className="btn btn-sm background-rojo-megatone" onClick={onSubmit}>
                    Enviar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
